import React, { Component } from 'react';

export default class TutorialMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            category: null,
            video: null,
            isVideoActive: false
        }

        this.baseUrl = window.__globalConfig.baseUrl + '/Content/Videos/';

        this.manageVideoElement = this.manageVideoElement.bind(this);

        this.goAway = this.goAway.bind(this);

        this.setCategory = this.setCategory.bind(this);
        this.setVideo = this.setVideo.bind(this);

        this.generatePopupOptions = this.generatePopupOptions.bind(this);
    }

    manageVideoElement(element) {
        if (element) {
            element.setAttribute('webkit-playsinline', true);
        }
    }

    goAway() {
        let self = this;
        self.props.goAway(() => {
            setTimeout(() => {
                self.setState({
                    category: null,
                    video: null,
                    isVideoActive: false
                });
            }, 600);
        });
    }

    setCategory(category) {
        this.setState({ category: category })
    }

    setVideo(video) {
        let self = this;
        this.setState({ video: (video === null ? this.state.video : video), isVideoActive: (video === null ? false : true) }, () => {
            if (video === null) {
                setTimeout(() => {
                    self.setState({ video: null });
                }, 600);
            }
        });
    }

    generatePopupOptions() {
        let self = this;
        let resultJsxList = [];
        let mainHeaderClass = 'tutorial-main-header';
        if (this.state.category === null) {
            let categories = this.props.videos.reduce((r, e) => {
                if (!r.includes(e.category)) {
                    r.push(e.category);
                }
                return r;
            }, []);
            categories.forEach((category, index) => {
                resultJsxList.push((
                    <div key={category} className={'tutorial-category'} style={{ top: ((4.6 + index * 3) + 'rem') }} onClick={this.setCategory.bind(null, category)}>
                        {category}
                        <div className={"accent-bar"}></div>
                    </div>
                ));
            });
        } else {
            mainHeaderClass += ' hidden';
            resultJsxList.push((
                <div key={this.state.category} className={'tutorial-category active'} style={{ top: '0rem' }} onClick={this.setCategory.bind(null, null)}>
                    {this.state.category}
                    <div className={"accent-bar active"}></div>
                </div>
            ));
            let visibleVideos = this.props.videos.reduce((r, e) => {
                if (e.category === self.state.category) {
                    r.push(e);
                }
                return r;
            }, []);
            visibleVideos.forEach((video, index) => {
                resultJsxList.push((
                    <div key={video.name} className={'tutorial-category'} style={{ top: ((4.6 + index * 3) + 'rem') }} onClick={this.setVideo.bind(null, video)}>{video.name}</div>
                ));
            });
        }

        resultJsxList.unshift((
            <div className={mainHeaderClass}>Tutorials</div>
        ));

        return resultJsxList;
    }

    render() {

        let outerClass = 'tutorial-outer';
        if (!this.props.isActive) {
            outerClass += ' disabled';
        }

        let popupJsx = this.generatePopupOptions();

        return (
            <div className={outerClass}>
                <div className={"curtain"} onClick={this.goAway}></div>
                <div className={"popup"}>
                    <div className={"popup-inner"} style={{ height: ((2.6 + popupJsx.length * 3) + 'rem') }}>
                        {popupJsx}
                    </div>
                </div>
                <div className={"video-outer" + (this.state.isVideoActive ? ' active' : '')}>
                    <video ref={this.manageVideoElement} className={"video"} src={this.state.video === null ? '#' : this.baseUrl + this.state.video.url} autoPlay loop playsInline controls />
                    <div className={"material-icons video-closer"} onClick={this.setVideo.bind(null, null)}>{"close"}</div>
                </div>
            </div>
        );
    }
}